module.exports = __webpack_public_path__ + "img/6.660c2d22.jpg";